import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { api, toRecord } from 'utils'
import { RequestStatus } from 'types'
import { Space } from '../map/types'
import { RootState } from '../../store'

interface IterableResponse<T> {
    results: T[]
}

export const fetchSpaces = createAsyncThunk(
    'fetchSpaces',
    async ({ eventSlug }: { eventSlug: string }) => {
        const url = `/events/${eventSlug}/organizer/spaces/`
        const response = await api.get<IterableResponse<Space>>(url)
        return response.results as Space[]
    },
)

const spacesSlice = createSlice({
    name: 'spacesSlice',
    initialState: {
        spaces: {} as Record<number, Space>,
        spacesRequestStatus: 'idle' as RequestStatus,
    },
    reducers: {},
    extraReducers: (builder) => builder
        .addCase(fetchSpaces.fulfilled, (state, { payload }) => {
            state.spaces = toRecord(payload)
            state.spacesRequestStatus = 'succeeded'
        })
        .addCase(fetchSpaces.rejected, (state) => {
            state.spaces = {}
            state.spacesRequestStatus = 'failed'
        }),
})

export const selectSpaces = (state: RootState) => Object.values(state.spaces.spaces)
export const selectRequestStatus = (state: RootState) => state.spaces.spacesRequestStatus

export default spacesSlice.reducer
